import { render, staticRenderFns } from "./export_button.vue?vue&type=template&id=38bc229e&scoped=true&lang=pug"
import script from "./export_button.vue?vue&type=script&lang=js"
export * from "./export_button.vue?vue&type=script&lang=js"
import style0 from "./export_button.vue?vue&type=style&index=0&id=38bc229e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc229e",
  null
  
)

export default component.exports